import { SET_SERVICE_INSURANCE_URL } from "service/actionType";

const initialState = {
  serviceUrl: ''
};

const serviceInsuranceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SERVICE_INSURANCE_URL:
      return {
        ...state,
        serviceUrl: action.payload,
      };
    default:
      return state;
  }
};

export default serviceInsuranceReducer;